module.exports = __webpack_public_path__ + "static/img/pcmapen.265a01a.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/pcmapen.png
// module id = F0h/
// module chunks = 45